import React, { useCallback, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
// import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import handleCSRF from "../../../config/CSRF";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import DeleteModal from "../../../components/Modal/DeleteModal";

export default function Coupon() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      accessorKey: "id",
    },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Code") || "Code",
      accessorKey: "code",
    },
    {
      header:
        languageHelper("Minimum Purchase Price") || "Minimum Purchase Price",
      accessorKey: "minimum_purchase_price",
    },
    {
      header: languageHelper("Discount") || "Discount",
      accessorKey: "discount_amount",
    },
    {
      header: languageHelper("Discount Type") || "Discount Type",
      accessorKey: "dis_type",
      cell: (row) =>
        row.getValue() === "percentage" ? "Percentage" : "Amount",
    },
    {
      header: languageHelper("Expired date") || "Expired date",
      accessorKey: "expired_date",
      cell: (row) => new Date(row.getValue()).toLocaleDateString(),
    },
    {
      header: languageHelper("Status") || "Status",
      accessorKey: "status",
      cell: (row) => (Number(row.getValue()) === 1 ? "Active" : "Inactive"),
    },
    {
      header: languageHelper("Actions") || "Actions",
      accessorKey: "SN",
      cell: (row) => (
        <Dropdown options={dropdownOptions} id={row.row.original.id} />
      ),
    },
  ];

  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddCouponForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        setDeleteId(id);
      },
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/coupons/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchCoupons();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchCoupons = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/coupons`, {
        headers: {
          withCredentials: true,
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
        setPageLoading(false);
      })
      .catch((err) => {
        setPageLoading(false);
        setError("Cannot load data");
      });
  }, [user?.token]);
  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchCoupons);
  }, [fetchCoupons, user.token]);
  const [data, setData] = useState([]);

  const buttonData = [
    {
      buttonText: languageHelper("Add Coupon"),
      path: "AddCouponForm",
    },
  ];
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Coupon")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {deleteId && (
        <DeleteModal
          onDelete={() => handleDelete(deleteId)}
          setIsOpen={setDeleteId}
        />
      )}
    </main>
  );
}
